"use strict";
/*
 * Created on 28. 1. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");

var CSVExportedPriceListRow_1 = require("../model/CSVExportedPriceListRow");
/**
 * @author Radek Beran
 */


var CSVExportedPriceListRowConverterImpl =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(CSVExportedPriceListRowConverterImpl, _DataObjectConverter_);

  function CSVExportedPriceListRowConverterImpl() {
    _classCallCheck(this, CSVExportedPriceListRowConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(CSVExportedPriceListRowConverterImpl).apply(this, arguments));
  }

  _createClass(CSVExportedPriceListRowConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return CSVExportedPriceListRow_1.CSVExportedPriceListRow.fromDocument(source, conversions);
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      throw new Error("Not implemented");
    }
  }]);

  return CSVExportedPriceListRowConverterImpl;
}(DataObjectConverter_1.DataObjectConverter);

exports.CSVExportedPriceListRowConverterImpl = CSVExportedPriceListRowConverterImpl;